import { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const ToastNotification = ({ message, type = 'success', isVisible, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose, duration]);

  if (!isVisible) return null;

  const config = {
    success: { icon: 'CheckCircle2', color: 'var(--color-success)', bg: 'var(--color-success)' },
    error: { icon: 'XCircle', color: 'var(--color-destructive)', bg: 'var(--color-destructive)' },
    info: { icon: 'Info', color: 'var(--color-primary)', bg: 'var(--color-primary)' }
  };

  const { icon, color, bg } = config?.[type] || config?.success;

  return (
    <div 
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[1001] animate-slideUp"
      role="alert"
      aria-live="polite"
    >
      <div 
        className="bg-card rounded-lg shadow-soft-xl px-4 py-3 md:px-6 md:py-4 flex items-center gap-3 min-w-[280px] max-w-md"
        style={{ borderLeft: `4px solid ${bg}` }}
      >
        <Icon name={icon} size={20} color={color} />
        <p className="text-sm md:text-base text-foreground flex-1">
          {message}
        </p>
        <button
          onClick={onClose}
          className="flex-shrink-0 w-6 h-6 rounded-full hover:bg-muted flex items-center justify-center transition-colors duration-250"
          aria-label="Close notification"
        >
          <Icon name="X" size={16} color="var(--color-muted-foreground)" />
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;